<template>
    <div class="header--app">
        <div class="header--auth">
            <a class="header--auth__back" href="#" :class="{ visible: backLink }" @click.prevent="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
                    <g stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd">
                        <path d="M10.374 17.3L2 9 10.374.7M2 9h18"/>
                    </g>
                </svg>
            </a>

            <router-link class="header--auth__welcome" :to="{ name: 'welcome'}">
                <img class="header--auth__logo" src="/images/bahai-logo-small-white.svg" />
                <span class="header--auth__name">Spiritual Assembly of the Bahá'ís of Auckland</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            backLink: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>
